import { combineReducers } from "redux";
import processo from "./paginas/processo/reducers";
import mensagem from "./componentes/mensagem/reducers";
import anexo from "./componentes/anexo/reducers";
import usuario from "./componentes/usuario/reducers";
import pesquisaprocesso from "./paginas/pesquisaprocesso/reducers";
import editor from "./componentes/editor/reducers";
import decisao from "./paginas/decisao/reducers";
import parecer from "./paginas/parecer/reducers";

export default combineReducers({
  processo,
  anexo,
  usuario,
  pesquisaprocesso,
  mensagem,
  editor,
  decisao,
  parecer
});



// WEBPACK FOOTER //
// ./src/reducers.js